/**
 * @generated SignedSource<<a539184627ac0c909e833e3b5aa4f7f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type shareUserPromotionQuery$variables = {
  promotionCode: string;
  skip: boolean;
};
export type shareUserPromotionQuery$data = {
  readonly getRefundUserPromotion?: {
    readonly code: string | null | undefined;
    readonly isTerm: boolean | null | undefined;
  };
};
export type shareUserPromotionQuery = {
  response: shareUserPromotionQuery$data;
  variables: shareUserPromotionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "promotionCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "promotionCode",
            "variableName": "promotionCode"
          }
        ],
        "concreteType": "RefundUserPromotionOutput",
        "kind": "LinkedField",
        "name": "getRefundUserPromotion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTerm",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "shareUserPromotionQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "shareUserPromotionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6f1ac05b9d8b75c6788610abb7214c0d",
    "id": null,
    "metadata": {},
    "name": "shareUserPromotionQuery",
    "operationKind": "query",
    "text": "query shareUserPromotionQuery(\n  $promotionCode: String!\n  $skip: Boolean!\n) {\n  getRefundUserPromotion(promotionCode: $promotionCode) @skip(if: $skip) {\n    code\n    isTerm\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6ca5c95b58a50646d268d342b78a670";

export default node;
